var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){return _vm.changeMessage()}}},[_vm._v("Нажми сюда")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }